<script>
const axios = require("axios");

export default {
	mixins: [require("@/mixins/backend-mixin").default],
	data() {
		return {
			PERMISSIONS: []
		};
	},
	computed: {
		userTypes() {
			return this.PERMISSIONS;
		}
	},
	async mounted() {
		await this.BACKEND_URL;
		await this.getPermissions();
	},
	methods: {
		async getPermissions() {
			this.PERMISSIONS = this.$store.state.permissions;

			if (Object.keys(this.PERMISSIONS).length) {
				return;
			}

			if ([false, true].indexOf(true)) {
				console.log("Getting STATIC permissions");
				this.staticPermissions();
				this.$store.dispatch("setPermissions", this.PERMISSIONS);
				return;
			}

			console.log("Getting permissions");
			const url = this.BACKEND_URL + "/api/";
			const thisVue = this;

			await axios
				.get(url)
				.then(response => {
					if (response.status == 200) {
						thisVue.PERMISSIONS = response.data.data;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		staticPermissions() {
			const Super_Admin = 0;
			const Admin = 1;
			const Eye_Specialist = 2;
			const Camera_Man = 3;
			const Data_Entry = 4;
			const Patient = 5;

			this.PERMISSIONS = {
				[Super_Admin]: {
					CLINIC_MANAGMENT: true,
					ADMIN_MANAGMENT: true,
					FULL_USERS_MANAGMENT: true,
					FULL_BACKUP: true,
					BACKUP_RESTORE: true
				},
				[Admin]: {
					OWN_CLINIC_MANAGMENT: true,
					OWN_USERS_MANAGMENT: true,
					STATE_STAGE_MANAGMENT: true,
					BACKUP: true,
					QUESTION_MANAGMENT: true,
					LOG_READ: true,
					SMS_MANAGMENT: true
				},
				[Eye_Specialist]: {
					VIEW_PATIENTS: true,
					GRADING: true,
					RANDOM_GRADING: true,
					REFER_GRADING: true,
					VIEW_OWN_GRADING: true,
					MODIFY_OWN_PROFILE: true
				},
				[Camera_Man]: {
					CHECKUP: true,
					MODIFY_OWN_PROFILE: true,
					VIEW_WAITING_APPOINTMENTS: true
				},
				[Data_Entry]: {
					OWN_PATIENTS_MANAGMENT: true,
					APPOINTMNETS_MANAGMENT: true,
					MODIFY_OWN_PROFILE: true
				},
				[Patient]: {
					// No permissions (yet)
				}
			};
		}
	}
};
</script>